import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { HttpClientModule } from '@angular/common/http';
import { AppComponent } from "./app.component";
import { LeafletModule } from "@asymmetrik/ngx-leaflet";
import { LeafletDrawModule } from "@asymmetrik/ngx-leaflet-draw";
import { LeafLetComponent } from './leaf-let/leaf-let.component';
import { SupervisorComponent } from './supervisor/supervisor.component';
import { TestComponent } from './test/test.component';
import { AppRoutingModule } from './app-routing.module';

@NgModule({
	declarations: [AppComponent, LeafLetComponent, SupervisorComponent,TestComponent],
	imports: [BrowserModule,HttpClientModule, LeafletModule, LeafletDrawModule,AppRoutingModule],
	providers: [],
	bootstrap: [AppComponent]
})
export class AppModule {}
